import { Component } from '@angular/core';

@Component({
    templateUrl: './root.component.html',
    standalone: false
})
export class RootComponent {
}
